import {
  MatterSectionCard,
  MatterSectionCardLineItem,
} from "@/components/features/matter/layout/MatterSectionCard/MatterSectionCard";
import { useUser } from "@/components/UserProvider";
import { useGlobalModal } from "@/hooks/useGlobalModal";
import {
  ACTION_PERMISSION_KEYS,
  ACTION_PERMISSION_VALUES,
} from "@/lib/data/static/permissionOptions";
import { type Matter } from "@/lib/types";
import { Check, X } from "lucide-react";

export const MatterInjuries = ({
  matter,
  noBorder = false,
}: {
  matter: Matter;
  /** Omit inner section border when wrapped in an outer bordered card (e.g. client tab). */
  noBorder?: boolean;
}) => {
  const { hasActionPermission } = useUser();
  const { openCaseInjuriesModal } = useGlobalModal();

  return (
    <MatterSectionCard
      title="Injuries"
      hasUpdatePermission={hasActionPermission(
        ACTION_PERMISSION_KEYS.matter,
        ACTION_PERMISSION_VALUES.update,
      )}
      onUpdateClick={() => {
        openCaseInjuriesModal({
          matterId: matter.id,
        });
      }}
      noHeaderBackground
      noBorder={noBorder}
    >
      <MatterSectionCardLineItem
        title="Client injury description"
        valueClassName="whitespace-pre-wrap"
        value={matter.clientInjuryDescription ?? "-"}
      />

      <MatterSectionCardLineItem
        title="Visible bodily injury"
        value={
          matter.clientVisibleBodilyInjury ? (
            <Check className="text-green-500" />
          ) : (
            <X className="text-red-500" />
          )
        }
      />
      <MatterSectionCardLineItem
        title="Client prior injury"
        value={
          matter.clientPriorInjury ? (
            <Check className="text-green-500" />
          ) : (
            <X className="text-red-500" />
          )
        }
      />
      {matter.clientPriorInjury && (
        <MatterSectionCardLineItem
          title="Prior injury description"
          valueClassName="whitespace-pre-wrap"
          value={matter.clientPriorInjuryDescription ?? "-"}
        />
      )}
      {matter.clientPriorInjury && (
        <MatterSectionCardLineItem
          title="Prior injury legal representation"
          value={
            matter.clientPriorInjuryLegalRepresentation ? (
              <Check className="text-green-500" />
            ) : (
              <X className="text-red-500" />
            )
          }
        />
      )}
    </MatterSectionCard>
  );
};
